import React from 'react';
import { connect } from 'react-redux';
import WorkRequestSeparation from '../../components/templates/WorkRequestSeparation';
import { authOperations } from '../../reducks/auth';
import { commonOperations } from '../../reducks/common';
import { workOperations } from '../../reducks/work';

const mapStateToProps = state => ({
  currentTheme: state.style.theme,
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = {
  sendAuthenticationAction: authOperations.sendAuthenticationCodeOperation,
  doOpenDialog: commonOperations.doOpenDialog,
  doWorkRequestSeparationAction: workOperations.doWorkRequestSeparationOperation
};

class App extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (<WorkRequestSeparation
      {...this.props}
    />);
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ContainerApp;
